<template>
  <div class="foo">
    <div id="fucklogin">
      <el-row class="fucko">
        <el-col :span="18">
          <h2 class="title">ST广播系统</h2>
        </el-col>
      </el-row>
      <el-row class="fucko">
        <el-col :span="18">
          <el-input v-model="input_username" placeholder="username">
            <template slot="prepend">账号:</template>
          </el-input>
        </el-col>
      </el-row>

      <el-row class="fucko">
        <el-col :span="18">
          <el-input v-model="input_passwd" type="password" placeholder="password">
            <template slot="prepend">密码:</template>
          </el-input>

          <el-button class="fucko" type="primary" @click="loginii" plain>Login[登录]</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from 'qs'
export default {
  data() {
    return {
      input_passwd: "",
      input_username: ""
    };
  },
  created() {


    if (this.Pass && this.Phone) {
      sessionStorage.removeItem("token");
      let base1s = hpps1 + "user/checkin.boxuds";
      let phone = this.Phone;
      let pass = this.Pass;
      axios
        .post(
          base1s,
          {
            action: "user/checkin",
            params: {
              login_id: phone,
              passwd: pass,
              type: 0
            }
          },
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(
          function(res) {
            if (res.data.code == 8200) {
              console.log(res.data.result.token);
              sessionStorage.setItem("token", res.data.result.token);
              this.$router.push({ path: "/" });
            } else {
              alert(res.data.msg);
            }
          }.bind(this)
        )
        .catch(function(error) {
          alert("error: " + error);
        });
    }

  //http://129.211.117.94:8081/user/fnckukei/listmydevice
	console.log(this.$router.currentRoute.query.username);
	console.log(this.$router.currentRoute.query.passwd);
	if(this.$router.currentRoute.query.passwd  != undefined && this.$router.currentRoute.query.passwd != undefined ){
			 console.log("传参传入了账号密码");
       let data = new FormData();
       data.append("username", this.$router.currentRoute.query.username);
       data.append("passwd", this.$router.currentRoute.query.passwd);
			 axios
			   .postForm("user/fnkukei/gtoken", data )
			   .then(
			     function(res) {
			       if (res.data.res) {
			         sessionStorage.setItem("token", res.data.data.token);
			         sessionStorage.setItem("username", res.data.data.user_name);
			         sessionStorage.setItem("id", res.data.data.id);
			         sessionStorage.setItem("passwd", res.data.data.user_pass);
			         sessionStorage.setItem("user_type", res.data.data.user_type);
			         sessionStorage.setItem("master_id", res.data.data.master_id);
			         sessionStorage.setItem("mask", res.data.data.mask);
			         sessionStorage.setItem("play_level", res.data.data.play_level);
			         sessionStorage.setItem("user_level", res.data.data.user_level);
               sessionStorage.setItem("nickname", res.data.data.nickname);
			         if(res.data.data.master_id == -99){
                 this.$router.push({ path: "/mglg" });
			         }else{
                 this.$router.push({ path: "/mgll" });
               }
			         this.$notify.success({
			           title: "Info",
			           message: "验证通过",
			           showClose: false
			         });
			       } else {
			         this.$notify.success({
			           title: "Info",
			           message: "验证不通过",
			           showClose: false
			         });
			       }
			     }.bind(this)
			   )
			   .catch(function(res) {
			     console.log(res);
			   });

	}else{
			 console.log("没有传入账号密码");
	}
  },
  methods: {
    loginii() {
    let data = new FormData();
    data.append("username", this.input_username);
    data.append("passwd", this.input_passwd);
      axios
        .post("user/fnkukei/gtoken", data )
        .then(
          function(res) {
            if (res.data.res) {
              sessionStorage.setItem("token", res.data.data.token);
              sessionStorage.setItem("username", res.data.data.user_name);
              sessionStorage.setItem("id", res.data.data.id);
              sessionStorage.setItem("passwd", res.data.data.user_pass);
              sessionStorage.setItem("user_type", res.data.data.user_type);
              sessionStorage.setItem("master_id", res.data.data.master_id);
              sessionStorage.setItem("mask", res.data.data.mask);
              sessionStorage.setItem("play_level", res.data.data.play_level);
              sessionStorage.setItem("user_level", res.data.data.user_level);
              sessionStorage.setItem("nickname", res.data.data.nickname);
              if(res.data.data.master_id == -99){
                this.$router.push({ path: "/mglg" });
              }else{
                this.$router.push({ path: "/mgll" });
              }
              this.$notify.success({
                title: "Info",
                message: "验证通过",
                showClose: false
              });
            } else {
              this.$notify.success({
                title: "Info",
                message: "验证不通过",
                showClose: false
              });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
  },
  computed: {
    Phone() {
      return sessionStorage.getItem("phone");
    },
    Pass() {
      return sessionStorage.getItem("pass");
    }
  }
};
</script>

<style scoped>
.foo {
  width: 100%;
  height: 100%;
  background: url(../assets/login_bg.jpg);
  position: fixed;
	background-repeat:no-repeat;
	background-position: 0px 0px;
	background-size:100% 100%;
}
.title {
  color: white;
}
.fucko {
  margin-top: 10px;
}
#fucklogin {
  margin: 15% auto;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/xxxvue/Foo.vue